<div class="dialog-container">
  <div class="offline-icon">
    <img [src]="noInternetIcon()" alt="No Network" />
  </div>
  <h3 mat-dialog-title>{{ 'TOAST.NO_INTERNET_TITLE' | translate }}</h3>
  <mat-dialog-content>{{ 'TOAST.NO_INTERNET_CONTENT' | translate }}</mat-dialog-content>
</div>
